module.exports = __webpack_public_path__ + "static/media/ladd6.fcf37e29.jpg";